module.exports = __webpack_public_path__ + "img/course_bg7.214317d6.png";